import axios from 'axios'

const BASE_URL = import.meta.env.VITE_API_BASE_URL
export const getAllgenderService = async () => {
  const STORAGE_TOKEN = JSON.parse(window.localStorage.getItem('token'))

  let config = {
    headers: {
      Authorization: 'Bearer ' + STORAGE_TOKEN,
    },
    withCredentials: true,
  }

  return await axios
    .get(`${BASE_URL}gender`, config)
    .then((response) => {
      return {
        data: response.data,
        responseStatus: response.status,
      }
    })
    .catch(function (error) {
      if (error.response.status === 401) {
        window.localStorage.clear()
        window.location.reload()
      }
      console.log('error genderService', error.response.data)
      return error
    })
}
